// extracted by mini-css-extract-plugin
module.exports = {"header-categories-menu-icon-button__arrow-up":"HeaderCategoriesMenuIconButton_header-categories-menu-icon-button__arrow-up__flMBQ"};